import HttpRequest from "./fetch";

export const fetcher = new HttpRequest().fetcher;

// 节流
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const throttle = <T extends (...args: any[]) => void>(
  cb: T,
  timeout = 100,
) => {
  let state = false;
  return (...args: Parameters<T>) => {
    if (state) return;
    state = true;
    setTimeout(() => {
      cb(...args);
      state = false;
    }, timeout);
  };
};

export function deepclone(target: any, map = new WeakMap()) {
  if (!target || typeof target !== "object") return target;
  if (target instanceof Date) return new Date(target);
  if (target instanceof RegExp) {
    const reg = new RegExp(target.source, target.flags);
    reg.lastIndex = target.lastIndex;
    return reg;
  }
  if (map.get(target)) return map.get(target);
  const cloneTarget = new target.constructor();
  map.set(target, cloneTarget);
  const keys = Object.keys(target);
  for (const key in keys) {
    cloneTarget[key] = deepclone(target[key], map);
  }

  return cloneTarget;
}

function _curry(fn: any, len: number, ...rest: any[]) {
  return function (...params: any[]) {
    const args = [...rest, ...params];
    if (args.length >= len) {
      return fn(...args);
    } else {
      return _curry(fn, len, ...args);
    }
  };
}
export function curry(fn: any, len = fn.length, ...rest: any[]) {
  return _curry(fn, len, rest);
}

// function create(proto: any, prot?: any) {
//   function F() {}
//   F.prototype = proto;
//   const obj = new F();
//   if (prot) {
//     Object.defineProperties(obj, prot)
//   }
//   return obj;
// }

// function _call(target: any, ...rest: any[]) {
//   const key = Symbol()
//   target[key] = this;
//   const result = target[key](...rest);
//   delete target[key];
//   return result;
// }

// function bind(target: any, ...rest: any[]) {
//   const that = this;
//   return function fn(...params: any[]) {
//     const thisArgs = this instanceof fn ? this : target;
//     that.apply(thisArgs, [...rest, ...params])
//   }
// }
// function _new(target: any, ...rest: any[]) {
//   const obj = new Object();
//   Object.setPrototypeOf(obj, target.prototype)
//   target.call(obj)
//   return obj;
// }